<template>
  <v-container class="pa-0">
    <!-- Dropdown -->
    <v-select
      :key="filter.id"
      v-if="filter.inputTypeId === inputTypeId_Dropdown"
      v-model="filter.value"
      :items="filter.dropdownItems"
      :label="filter.label"
      hide-details
      class="pb-2"
    />

    <!-- Multi-select -->
    <v-select
      :key="filter.id"
      v-if="filter.inputTypeId === inputTypeId_MultiSelect"
      v-model="filter.multiSelectValues"
      :items="filter.multiSelectItems"
      multiple
      small-chips
      filled
      :label="filter.description"
      hide-details
      class="pb-2"
    />
  </v-container>
</template>

<script>
import { InputTypeId  } from '@/config.js'

export default {
  name: 'UserFilter',
  props: {
    filter: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // input type ids
      inputTypeId_Dropdown: InputTypeId.Dropdown,
      inputTypeId_MultiSelect: InputTypeId.MultiSelect
    }
  }
}
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0 !important  
}
</style>
